// extracted by mini-css-extract-plugin
export default {"button":"ll7usGPAqwXq_gSFpyJL","button--primary":"FEMU5oYLKXfgfBNrw_Vx","button--confirm":"TUvq0_Do7gZeOHi5k5K2","button--small":"sxYeWJNjJlkPDy0Y98VA"};